import { CheckmarkIcon } from '@/public/assets/v2/images/icons'
import { Text } from '../typography/Text'

export interface OptionCheckbox<T> {
  value: T
  label: string | React.ReactNode
}

interface Props<T> {
  options: OptionCheckbox<T>[]
  onChange: (option: OptionCheckbox<T>) => void
  optionSelected?: OptionCheckbox<T>
  name?: string
}

// interface CheckboxProps<T> {
//   option: OptionCheckbox<T>
//   onChange: (option: OptionCheckbox<T>) => void
//   isOptionSelected: (option: OptionCheckbox<T>) => boolean
//   getCheckboxClass: (option: OptionCheckbox<T>) => string
// }

export const CheckboxGroup = <T extends unknown>({
  options,
  onChange,
  optionSelected,
  name,
}: Props<T>) => {
  const handleChange = (option: OptionCheckbox<T>) => {
    onChange(option)
  }

  const isOptionSelected = (option: OptionCheckbox<T>) => {
    return optionSelected?.value === option.value
  }

  const getCheckboxClass = (option: OptionCheckbox<T>) => {
    const isSelected = isOptionSelected(option)
    const bg = !isSelected ? '' : 'bg-accent-primary'
    const border = !isSelected ? 'border-primary' : 'border-accent-primary'
    return `border-solid border-1 rounded-30 flex items-center justify-center ${bg} ${border}`
  }

  return (
    <div className="flex flex-column gap-10">
      {options.map((option, index) => (
        <div
          key={index + (name || '_option_checkbox')}
          className="flex gap-8 cursor-pointer"
          onClick={() => handleChange(option)}
        >
          <div className="pt-2">
            <div
              style={{
                width: 20,
                aspectRatio: '1/1',
              }}
              className={getCheckboxClass(option)}
            >
              {isOptionSelected(option) && (
                <CheckmarkIcon className="text-10" />
              )}
            </div>
          </div>
          <Text colorClass="text-secondary" sizeClass="text-15">
            {option.label}
          </Text>
        </div>
      ))}
    </div>
  )
}
